import Bowser from "bowser";

// parseQuery parses a query to associative array object.
export function parseQuery(query) {
    'use strict';

    var queryObj = {};
    var a = (query[0] === '?' ? query.substr(1) : query).split('&');
    for (var i = 0; i < a.length; ++i) {
        var b = a[i].split('=');
        queryObj[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
    }

    return queryObj;
}

// load the specified script
export async function loadScript(url, async) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = !!async;
        script.onreadystatechange = () => resolve();
        script.onload = () => resolve();
        document.head.appendChild(script);
    });
}

// load the scripts array
export async function loadScripts(urls) {
    return Promise.all([urls.map(url => loadScript(url))]);
}

// load the scripts array sequentially
export async function loadScriptsSequentially(urls) {
    for (let i = 0; i < urls.length; ++i) {
        await loadScript(urls[i]);
    }
}

// objectToQueryString converts the specified object to URL query string.
export function objectToQueryString(obj) {
    var query = Object.keys(obj).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    }).join('&')
    return query;
}

// buildHttpResponse creates the fake object with some properties of successfull AJAX response.
export function buildHttpResponse(responseURL, data) {
    var fakeXMLHttpRequest = {};
    fakeXMLHttpRequest.readyState = 4;
    fakeXMLHttpRequest.response = data;
    fakeXMLHttpRequest.responseText = data;
    fakeXMLHttpRequest.responseURL = responseURL;
    fakeXMLHttpRequest.status = 200;
    fakeXMLHttpRequest.statusText = "OK";
    return fakeXMLHttpRequest;
}

// assert throws an error if the specified expression evaluates to false.
export function assert(expr, msg) {
    'use strict';

    if (!expr) {
        throw new Error(msg || "Assertion failed. See the stack trace.");
    }
}

export function decodeArray(str) {
    const decoded = Buffer.from(str, 'base64').toString();
    const result = [];
    for (let i = 0; i < decoded.length; ++i) {
        result.push(decoded.charCodeAt(i));
    }
    return result;
}

const browser = Bowser.getParser(window.navigator.userAgent);

export function isTablet() {
    return browser.getPlatformType().toLowerCase().includes("tablet");
}

export function isMobile() {
    return browser.getPlatformType().toLowerCase().includes("mobile");
}

export function isDesktop() {
    return browser.getPlatformType().toLowerCase().includes("desktop");
}

export function isiOS() {
    return browser.getOSName().toLowerCase().includes("ios");
}

export function isAndroid() {
    return browser.getOSName().toLowerCase().includes("android");
}
